import _ from 'lodash';
import log from 'loglevel';

let config = null;

const defaultConfig = {
  userApi: '/api/users',
  graphApi: '/graphql',
  googleAnalyticsId: 'UA-86901020-7',
  mockOverviewBannerEndDate: '2019-02-16',
  lineContactLink: 'https://line.me/R/ti/p/%40tcastermock',
  enableStudentRegistration: false,
  facebookAppId: '851361875011371',
  tcasterAppLink: 'https://www.tcaster.net/about-tcaster',
};

export function getConfig() {
  if (config === null) {
    config = _.defaultsDeep({}, window.appConfig, defaultConfig);
    console.log(log.getLevel()); // eslint-disable-line no-console
    log.warn(config);
  }
  return config;
}

export default getConfig;
